export default {
    testing: 'https://telemetrianode.hmhsistemas.com.mx:7069',
    production: 'https://telemetrianode.hmhsistemas.com.mx:7070'
}